import constants from '@core/utils/constants';
import { bus } from '@core/events/eventSystem';
import { serializer } from './serializer';
import { getStore } from '@core/store';

bus.on(constants.EVENTS.WALLET.REFRESH, (data) => {
  if (!data.userId) return;
  const userId = data.userId
  const requestId = `waallet-${Date.now()}`;

  let url = `${constants.ENDPOINTS.WALLET.GET}`;
  url = url.replace('{userId}', userId);

  bus.emit(EVENTS.WALLET.REFRESHING, { userId });
  bus.emit(constants.EVENTS.NETWORK.REQUEST, {
    id: requestId,
    url,
    method: 'GET',
    data: {}
  });

  bus.on(constants.EVENTS.NETWORK.RESPONSE, (res) => {
    if (res.id === requestId) {
      const parsed = serializer.deserialize(res);
      if (parsed.success) {
        parsed.data.userId = userId;
        bus.emit(EVENTS.WALLET.REFRESHED, parsed.data);
      } else {
        bus.emit(EVENTS.WALLET.REFRESH_ERROR, { userId, error: parsed });
      }
    }
  });
});
